import UniqueId from '../../services/uid/UniqueId';
import { AppState } from '../reducers/root';

export const getProcessStateForCategory = (
  state: AppState,
  categoryId: UniqueId
): Record<string, any> => state.actions.processState[categoryId];
